import indossamentIcon from "../../img/indosamentIcon.svg";
import editIcon from "../../img/editIcon.svg";
import collectIcon from "../../img/collectIcon.svg";
import releaseIcon from "../../img/releaseIcon.svg";
import annulateIcon from "../../img/clearIcon.svg";

//---BolToolBarItemsCaptain-------------------------------------------------------------------------------------------//
export const BolToolBarItemsCaptainToSign = [
    {value: 'Submit to bug fixes', icon: editIcon}
]

export const BolToolBarItemsCaptainRelease = [
    {value: 'Send to release', icon: releaseIcon}
]

export const BolToolBarItemsCaptainConfirmAnnulate = [
    {value: 'Confirm annulate', icon: annulateIcon}
]

//---BolToolBarItemsForwarder-----------------------------------------------------------------------------------------//
export const BolToolBarItemsForwarderRelease = [
    {value: 'Send to release', icon: releaseIcon}
]

//---BolToolBarItemsOwner---------------------------------------------------------------------------------------------//
export const BolToolBarItemsOwnerIssued = [
    {value: 'Add Indossament', icon: indossamentIcon},
    {value: 'Send to collect', icon: collectIcon},
    {value: 'Annulate', icon: annulateIcon}
]

export const BolToolBarItemsOwnerDraftToCorrectToSign = [
    {value: 'Annulate', icon: annulateIcon}
]

//---ManToolBarItemsCaptain-------------------------------------------------------------------------------------------//
export const ManToolBarItemsCaptainToSign = [
    {value: 'Submit to bug fixes', icon: editIcon},
]

export const ManToolBarItemsCaptainRelease = [
    {value: 'Send to release', icon: releaseIcon}
]

//---ManToolBarItemsForwarder-----------------------------------------------------------------------------------------//
export const ManToolBarItemsForwarderRelease = [
    {value: 'Send to release', icon: releaseIcon}
]

//---ManToolBarItemsOwner---------------------------------------------------------------------------------------------//
export const ManToolBarItemsOwnerDraftToCorrectToSign = [
    {value: 'Annulate', icon: annulateIcon}
]